// Newsletter de Bison (INI-1151). Una sola fuente para las listas que se pueden elegir, el texto de «qué vas a
// encontrar» y la lógica de los chips. ESM puro: lo usan la tarjeta de suscripción (blog, actualidad), la página
// /newsletter y los tests. Las listas viajan en el lead como campo «Listas»; el CRM las usará cuando INI-1081 lo conecte.
import { PAISES } from './rankings-countries.js';

export const NEWSLETTER_PATH = '/newsletter/';

export const LISTA_TODAS = 'todas';

export const LISTA_RANKINGS = 'rankings';

// Los chips: «Todas las actualizaciones», el blog y los rankings. El país va aparte, en su propio selector:
// «Todas» es el blog más los rankings del país elegido.
// Eventos y webinars todavía no existen: quien los elige queda anotado para cuando partan.
export const LISTAS = [
  { id: LISTA_TODAS, label: 'Todas las actualizaciones' },
  { id: 'blog', label: 'Blog' },
  { id: 'prensa', label: 'Prensa' },
  { id: LISTA_RANKINGS, label: 'Rankings' },
  { id: 'novedades', label: 'Novedades' },
  { id: 'eventos', label: 'Eventos' },
  { id: 'webinars', label: 'Webinars' },
];

// Los países del selector, en el orden de los rankings. Si la persona no elige, va Chile.
export const PAISES_NEWSLETTER = Object.entries(PAISES).map(([id, nombre]) => ({ id, nombre }));
export const PAIS_POR_DEFECTO = 'chile';

// Listas que dependen del país: los rankings y los eventos (presenciales). Los webinars no: son en línea.
export const LISTAS_POR_PAIS = [LISTA_RANKINGS, 'eventos'];

// El selector de país aparece si lo elegido incluye alguna lista por país («Todas» las incluye).
export const necesitaPais = (seleccion) =>
  seleccion.includes(LISTA_TODAS) || LISTAS_POR_PAIS.some((id) => seleccion.includes(id));

// Las listas reales a las que queda suscrita la persona; las que dependen del país, como «<lista>-<país>».
export function listasElegidas(seleccion, pais) {
  const todas = seleccion.includes(LISTA_TODAS);
  const p = PAISES[pais] ? pais : PAIS_POR_DEFECTO;
  return LISTAS.filter((l) => l.id !== LISTA_TODAS && (todas || seleccion.includes(l.id))).map((l) =>
    LISTAS_POR_PAIS.includes(l.id) ? `${l.id}-${p}` : l.id,
  );
}

// «Todas» es exclusiva: elegirla limpia el resto; elegir otra la quita. Sin ninguna elegida, vuelve «Todas».
export function alternarLista(seleccion, id) {
  if (id === LISTA_TODAS) return [LISTA_TODAS];
  const sin = seleccion.filter((x) => x !== LISTA_TODAS);
  const siguiente = sin.includes(id) ? sin.filter((x) => x !== id) : [...sin, id];
  return siguiente.length ? siguiente : [LISTA_TODAS];
}

// El texto del campo «Listas» del lead, con el nombre de cada lista en español («Blog, Rankings Chile, Eventos Chile»).
export const listasTexto = (seleccion, pais) =>
  listasElegidas(seleccion, pais)
    .map((id) => {
      const base = LISTAS_POR_PAIS.find((b) => id.startsWith(`${b}-`));
      const label = LISTAS.find((l) => l.id === (base || id)).label;
      return base ? `${label} ${PAISES[id.slice(base.length + 1)]}` : label;
    })
    .join(', ');

// Qué hay en el newsletter: lo mismo que se publica en el sitio, cada cosa con su página.
export const NEWSLETTER_CONTENIDO = [
  {
    id: 'blog',
    etiqueta: 'Blog',
    titulo: 'Artículos con datos y fuentes',
    texto:
      'Análisis largos sobre cómo la IA elige y recomienda marcas en LatAm. Cada artículo trae datos propios y dos fuentes verificadas.',
    href: '/blog/',
    enlace: 'Ver el blog',
  },
  {
    id: 'actualidad',
    etiqueta: 'Actualidad',
    titulo: 'Lo que cambia, en una nota corta',
    texto:
      'Novedades de los motores de IA y de la búsqueda, explicadas en pocas líneas y con la fuente a la vista.',
    href: '/actualidad/',
    enlace: 'Ver las notas',
  },
  {
    id: 'rankings',
    etiqueta: 'Rankings',
    titulo: 'Quién aparece, por industria y país',
    texto:
      'Qué marcas mencionan ChatGPT, Gemini y Claude en Chile, Argentina, Brasil, Colombia, Ecuador, México, Perú y Uruguay.',
    href: '/rankings/',
    enlace: 'Ver los rankings',
  },
  {
    id: 'prensa',
    etiqueta: 'Prensa',
    titulo: 'Nuestros datos, en los medios',
    texto: 'Las notas de prensa que citan nuestras mediciones, con el enlace a la fuente original.',
    href: '/nosotros/',
    enlace: 'Ver en los medios',
  },
  {
    id: 'novedades',
    etiqueta: 'Novedades',
    titulo: 'Lo nuevo en la plataforma',
    texto: 'Las funciones que sumamos a Bison y cómo usarlas para medir y mejorar la visibilidad de tu marca en IA.',
    href: '/plataforma/',
    enlace: 'Ver la plataforma',
  },
  {
    // Todavía no hay página de eventos: la tarjeta va sin enlace.
    id: 'eventos',
    etiqueta: 'Eventos y webinars',
    titulo: 'Sesiones en vivo',
    texto: 'Te avisamos de los eventos y webinars de Bison apenas abramos las inscripciones.',
  },
];
